import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';

const HeroSection = () => {
  const [hero, setHero] = useState({ 
    titleUr: '', titleEn: '', descUr: '', descEn: '', date: '', images: [], videos: [], category: 'center', newsCategory: 'Pakistan' 
  });
  const [uploading, setUploading] = useState(false);

  const handleFileUpload = async (file, index, type) => {
    if (!file) return;
    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "apurdu-news");
    const uploadUrl = `https://api.cloudinary.com/v1_1/dddxltark/${type === 'image' ? 'image' : 'video'}/upload`;

    try {
      const res = await fetch(uploadUrl, { method: "POST", body: formData });
      const data = await res.json();
      if (data.secure_url) {
        setHero(prev => {
          const updated = { ...prev };
          if (type === 'image') {
            const currentImages = [...(prev.images || [])];
            currentImages[index] = data.secure_url;
            updated.images = currentImages;
          } else {
            const currentVideos = [...(prev.videos || [])];
            currentVideos[index] = data.secure_url;
            updated.videos = currentVideos;
          }
          return updated;
        });
      }
    } catch (err) { alert("Upload Failed"); } finally { setUploading(false); }
  };

  const handleSave = async () => {
    if (!hero.titleEn && !hero.titleUr) return alert("Title daalna zaroori hai!");

    try {
      await addDoc(collection(db, "news"), {
        ...hero,
        randomHeroImage: hero.images.length > 0 ? hero.images[0] : null,
        timestamp: new Date().toISOString() 
      });
      alert(`News Published in ${hero.category.toUpperCase()} section with category [${hero.newsCategory}] successfully!`);
      
      // Reset State
      setHero({ 
        titleUr: '', titleEn: '', descUr: '', descEn: '', date: '', images: [], videos: [], category: 'center', newsCategory: 'Pakistan' 
      });
    } catch (err) { alert("Error: " + err.message); }
  };

  return (
    <div className="form-wrapper">
      <h2>Publish New News</h2>
      
      <div className="input-group">
        <label>Select Section</label>
        <select value={hero.category} onChange={(e) => setHero({...hero, category: e.target.value})}>
          <option value="center">Center / Featured Section</option>
          <option value="trending">Trending (Left Side)</option>
          <option value="more">More News (Right Side)</option>
        </select>
      </div>

      {/* New Category Input Selection */}
      <div className="input-group">
        <label>News Category (Roman Urdu)</label>
        <select value={hero.newsCategory} onChange={(e) => setHero({...hero, newsCategory: e.target.value})}>
          <option value="Pakistan">Pakistan</option>
          <option value="Taza Tareen">Taza Tareen (تازہ ترین)</option>
          <option value="Siyasat">Siyasat (سیاست)</option>
          <option value="Bain-Ul-Aqwami">Bain-Ul-Aqwami (بین الاقوامی)</option>
          <option value="Sehat">Sehat (صحت)</option>
          <option value="Shehar Ki News">Shehar Ki News (شہر کی نیوز)</option>
          <option value="Ishtiharat">Ishtiharat (اشتہارات)</option>
          <option value="Khel">Khel (کھیل)</option>
          <option value="Showbiz">Showbiz (شوبز)</option>
          <option value="Business">Business (بزنس)</option>
          <option value="Aaj Ka Column">Aaj Ka Column (آج کا کالم)</option>
        </select>
      </div>
      
      <div className="input-group"><label>عنوان (Urdu Title)</label><input dir="rtl" value={hero.titleUr} onChange={(e) => setHero({...hero, titleUr: e.target.value})} /></div>
      <div className="input-group"><label>Title (English)</label><input value={hero.titleEn} onChange={(e) => setHero({...hero, titleEn: e.target.value})} /></div>
      
      {/* Date Input Field */}
      <div className="input-group"><label>Date</label><input type="date" value={hero.date} onChange={(e) => setHero({...hero, date: e.target.value})} /></div>
      
      <div className="input-group" ><label>تفصیل (Urdu Description)</label><textarea dir="rtl" value={hero.descUr} onChange={(e) => setHero({...hero, descUr: e.target.value})} /></div>
      <div className="input-group"><label>Description (English)</label><textarea value={hero.descEn} onChange={(e) => setHero({...hero, descEn: e.target.value})} /></div>

      {/* Images & Videos Section */}
      <div className="dynamic-section">
        <label>Images</label>
        {hero.images.map((img, i) => (
          <div key={i} className="upload-box" style={{ display: 'flex', gap: '10px', marginBottom: '5px' }}>
            <input type="file" onChange={(e) => handleFileUpload(e.target.files[0], i, 'image')} />
            <span>{img ? '✅' : 'Pending'}</span>
          </div>
        ))}
        <button className="add-btn" onClick={() => setHero({...hero, images: [...hero.images, '']})}><Plus size={16}/> Add Image</button>
      </div>

      <div className="dynamic-section">
        <label>Videos</label>
        {hero.videos.map((vid, i) => (
          <div key={i} className="upload-box" style={{ display: 'flex', gap: '10px', marginBottom: '5px' }}>
            <input type="file" onChange={(e) => handleFileUpload(e.target.files[0], i, 'video')} />
            <span>{vid ? '✅' : 'Pending'}</span>
          </div>
        ))}
        <button className="add-btn" onClick={() => setHero({...hero, videos: [...hero.videos, '']})}><Plus size={16}/> Add Video</button>
      </div>

      <button className="submit-btn" style={{marginTop: '20px', width: '100%', padding: '15px'}} onClick={handleSave} disabled={uploading}>
        {uploading ? "Publishing..." : "Publish News"}
      </button>
    </div>
  );
};

export default HeroSection;